export default {"src":"/_next/static/media/ic_card.f6ce974c.svg","height":20,"width":21};